import AccordionList from 'src/components/HelpInfo/AccordionList';
import ContactAccordion from 'src/components/HelpInfo/ContactAccordion';
import FAQAccordion from 'src/components/HelpInfo/FAQAccordion';

const LeasedAssets = () => {
  const faqQuestions = [
    {
      question: 'Who is a Lessor?',
      answer: 'A person who leases or lets a property to another; a landlord.',
    },
    {
      question: 'Who is a Lessee?',
      answer: 'A person who holds the lease of a property; a tenant.',
    },
  ];

  return (
    <AccordionList>
      <AccordionList accordions={[<ContactAccordion key="contactAccordion" />]} />
      <FAQAccordion key={'faqAccordion'} questions={faqQuestions} />
    </AccordionList>
  );
};

export default LeasedAssets;
